import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, handleDateChange, initializeFilterData } from "../CommonComponents/CustomHooks";
import { CommonApiData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, InputBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const SMSReport = () => {
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch();
    const [result, setResult] = useState({ Data: [] });
    const [loading, setLoading] = useState(false);
    const [filterData, setFilterData] = useState(initializeFilterData);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const inputrefs = useRef([]);
    const commonData = CommonApiData();
    let pqrDate = new Date()
    let dateArr = pqrDate?.toString()?.split(' ')
    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`

    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
    };
    const userCode = CommonApiData().UserCode
    const loginUserType = CommonApiData().loginUserType
    const userName = CommonApiData().UserName
    const [formData, setFormData] = useState({
        ...Data,
        "fromDate": dateArr,
        "toDate": dateArr,
        "mobileNo": "",
        client: `${userCode} : ${userName}`,
        "event": ''
    })


    const handleChange1 = (event, value) => {
        GetSMSReport(value);
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleClear = async () => {
        await setFormData({
            ...Data,
            "fromDate": dateArr,
            "toDate": dateArr,
            "mobileNo": "",
            client: `${userCode} : ${userName}`,
            "event": ''
        })
        await inputrefs.current['txtFromDate'].focus()
        await setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const GetSMSReport = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...filterData,
            ...sortConfig,
            ...Data,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        await (setLoading(true))
        let data = await ApiCall('/api/Report/SMSReport', GetData)
        await (setLoading(false))
        if (data.Status === 'UNAUTHORIZED' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message);
        } else {
            setResult(data)
        }
        await (setLoading(false))
    }

    let ExportRequest = {
        ...Data,
        ...formData,
        ...filterData,
        Type: 'E',
        sortConfig,
        PageIndex: '1'
    }

    useEffect(() => {
        GetSMSReport();
        inputrefs.current['txtFromDate'].focus()
        document.title = 'SMS Report'
    }, [sortConfig]);

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{'SMS Report'}</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <DateBox
                            id='txtFromDate'
                            inputrefs={inputrefs}
                            label='From Date'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtLogDateTo'].focus() };
                            }}
                        />
                        <DateBox
                            id='txtLogDateTo'
                            inputrefs={inputrefs}
                            label='To Date'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    if (loginUserType.toUpperCase() === "CLIENT") {
                                        inputrefs.current['txtEvent'].focus()
                                    }
                                    else {
                                        inputrefs.current['txtClient'].focus()
                                    }

                                }
                            }}
                        />
                        <AutoCompleteBoxNew
                            id="txtClient"
                            label='Client'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtEvent'].focus()
                                }
                            }}
                            inputrefs={inputrefs}
                            maxLength='10'
                            placeholder='Client'
                            name='Client'
                            disabled={loginUserType === "CLIENT"}
                            value={loginUserType === "CLIENT" ? (formData.client || "") : ""}
                            onChange={(e) => setFormData({ ...formData, client: e.target.value })}
                            autocompleteType='GetClientData'
                        />
                        <AutoCompleteBoxNew
                            id="txtEvent"
                            label='Event'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtMobileNo'].focus()
                                }
                            }}
                            inputrefs={inputrefs}
                            maxLength='10'
                            placeholder='Event'
                            name='Event'
                            value={formData.event || ''}
                            autocompleteType='GetEventData'
                            contextKey={formData.client}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || ''
                                if (event.type !== 'keydown') {
                                    setFormData({ ...formData, event: newInputValue })
                                }
                            }}
                        />
                        <InputBox
                            label='Mobile No'
                            placeholder='Mobile No'
                            inputrefs={inputrefs}
                            id='txtMobileNo'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['btnSearch'].focus() };
                            }}
                            value={formData.mobileNo}
                            onChange={(e) => setFormData({ ...formData, mobileNo: e.target.value })}
                            autoComplete="off"
                        />
                    </div>
                    <div className='d-block mt-3 d-md-flex'>
                        <button
                            ref={ref => (inputrefs.current[`btnSearch`] = ref)}
                            onClick={GetSMSReport}
                            className="btn btn-rounded btn-primary">
                            <span className=" text-white me-2">
                                <i className="fa fa-search"></i>
                            </span>Search</button>
                        <button
                            className="btn btn-rounded btn-warning"
                            onClick={async () => {
                                try {
                                    dispatch(setSubLoading(true))
                                    await handleDownloadExcel('/api/Report/SMSReport', ExportRequest, 'SMS Report');
                                    dispatch(setSubLoading(false))
                                }
                                finally { dispatch(setSubLoading(false)) }
                            }} >
                            <span className="text-warning me-2">
                                <i className="fa fa-download text-white color-success"></i>
                            </span>
                            Export
                        </button>
                        <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                        </span>Reset</button>
                    </div>
                </div>
            </div>

            <Table
                PageName={"SMSReport"}
                loading={loading}
                handleFilter={() => {
                    GetSMSReport()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                setFilterData={setFilterData}
                tableData={result}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                Filter={false}
                onlyFilterPage={true}
            />

        </>
    )
}
export default SMSReport;